import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import { actionListaCaixasEntrada } from "src/actions/chamados/actionChamadosConfig";

const CardChamadoStatusChange = ({
    actionPhase,
    actionState,
    changeActionState,
    users,
    user
}) => {
    const { t } = useTranslation(['automation', 'common']);
    const [caixasEntrada, setCaixasEntrada] = useState([]);

    const statusOptions = [
        { value: "pendente", label: t('status.pending', { ns: 'common', defaultValue: 'Pendente' }) },
        { value: "aberto", label: t('status.open', { ns: 'common', defaultValue: 'Aberto' }) },
        { value: "concluido", label: t('status.completed', { ns: 'common', defaultValue: 'Concluído' }) },
        { value: "recusado", label: t('actionCards.chamadoStatusChange.statusRecusado', 'Recusado') },
        { value: "cancelado", label: t('actionCards.chamadoStatusChange.statusCancelado', 'Cancelado') },
    ];

    const tipoOptions = [
        { value: "interno", label: t('actionCards.chamadoStatusChange.typeInterno', 'Interno') },
        { value: "externo", label: t('actionCards.chamadoStatusChange.typeExterno', 'Externo') },
    ];

    useEffect(() => {
        async function fetchCaixasEntrada() {
            try {
                const response = await actionListaCaixasEntrada(`?cliente_id=${user?.clienteId}`);
                if (response.data?.data) {
                    setCaixasEntrada(response.data.data);
                }
            } catch (error) {
                console.error("Erro ao buscar caixas de entrada:", error);
            }
        }
        if (user?.clienteId && actionState?.chamadoTipo === "externo") {
            fetchCaixasEntrada();
        }
    }, [user?.clienteId, actionState?.chamadoTipo]);

    const caixasFormatted = caixasEntrada.map((c) => ({
        value: c._id,
        label: c.nome || c.titulo || c._id,
    }));

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label={t('actionCards.chamadoStatusChange.ticketTypeLabel', 'Tipo de chamado')}
                        info={t('actionCards.chamadoStatusChange.ticketTypeInfo', 'Filtrar por tipo de chamado (opcional)')}
                        input={
                            <Select
                                value={actionState?.chamadoTipo || ""}
                                onValueChange={(value) =>
                                    changeActionState({ name: "chamadoTipo", value: value || null })
                                }
                            >
                                <SelectTrigger>
                                    <SelectValue placeholder={t('actionCards.chamadoStatusChange.allTypesPlaceholder', 'Todos os tipos')} />
                                </SelectTrigger>
                                <SelectContent>
                                    {tipoOptions.map((opt) => (
                                        <SelectItem key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        }
                    />
                    {actionState?.chamadoTipo === "externo" && (
                        <RowInput
                            label={t('actionCards.chamadoStatusChange.inboxLabel', 'Caixa de entrada')}
                            info={t('actionCards.chamadoStatusChange.inboxInfo', 'Filtrar por caixa de entrada específica (opcional)')}
                            input={
                                <Select
                                    value={actionState?.chamadoCaixaEntradaId || ""}
                                    onValueChange={(value) =>
                                        changeActionState({ name: "chamadoCaixaEntradaId", value: value || null })
                                    }
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t('actionCards.chamadoStatusChange.allInboxesPlaceholder', 'Todas as caixas de entrada')} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {caixasFormatted.map((opt) => (
                                            <SelectItem key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            }
                        />
                    )}
                    <RowInput
                        label={t('actionCards.shared.targetStatusLabel', 'Status alvo')}
                        info={t('actionCards.chamadoStatusChange.targetStatusInfo', 'Filtrar por status de destino do chamado')}
                        input={
                            <MultiSelect
                                options={statusOptions}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chamadoTargetStatus", value: e })
                                }
                                defaultValue={actionState?.chamadoTargetStatus}
                                placeholder={t('actionCards.shared.selectStatusOptionalPlaceholder', 'Selecionar status (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        label={t('actionCards.chamadoStatusChange.assignedUserLabel', 'Usuário responsável')}
                        info={t('actionCards.chamadoStatusChange.assignedUserInfo', 'Filtrar por usuário direcionado no chamado')}
                        input={
                            <MultiSelect
                                options={users}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chamadoUsersAssign", value: e })
                                }
                                defaultValue={actionState?.chamadoUsersAssign}
                                placeholder={t('actionCards.shared.selectUsersOptionalPlaceholder', 'Selecionar usuários (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardChamadoStatusChange;
